import React, { useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import qs from "qs";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import QrIcon from "@material-ui/icons/CropFree";

import ApiUser from "../../../API/ApiUser";
import ApiTour from "../../../API/ApiTour";
import ApiZone from "../../../API/ApiZone";
import ApiAdmin from "../../../API/ApiAdmin";
import { getSizeInMb } from "../../../utils/sizeInMb";
import { GameMode } from "../../../constants/TourConstants";
import { ZoneMode } from "../../../constants/TourConstants";
import { withTranslation } from "react-i18next";

import styles from "./newTourStyles";
import TourView from "./newTourView";

class NewTour extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isAdmin: false,
      role: null,
      mapDialogOpen: false,
      showError: false,
      errorMessage: "",
      showSuccess: false,
      successMessage: "",
      showMusicFileTooBig: false,
      showBackgroundImageTooBig: false,
      showAnnotationImageTooBig: false,
      showInGameBackgroundImageTooBig: false,
      tourLoaded: false,
      zoneLoaded: false,
      editing: false,
      zonesOrderIdsChanged: false,
      dialogWaringOpened: false,
      loadingViewOpened: false,
      unsavedChanges: false,
      zoneIdToDelete: -1,
      mapType: "",
      showLatOnMap: null,
      showLngOnMap: null,
      selectedTab: "1",
      tutorialSteps: null,
      testCode: null,
      zones: [],
      zonesDatas: [],
      adminFormDatas: {
        accountStripeConnectActive: false,
        accountStripeConnectAuthorized: false,
        userCanMonetizedTour: false,
        stripeConnectCommissionPercent: 10,
        StripeConnectComissionFix: 1,
      },
      formDatas: {
        clientUserId: null,
        tourId: null,
        disabled: null,
        title: "",
        subtitle: "",
        gameMode: GameMode.ONLY_QRCODE,
        homeAnnotationName: "",
        mustAddAnalyticBeforeLaunch: false,
        redirectToHomeWhileFinished: false,
        cluesFree: false,
        askUserEmail: false,
        needDownloadMapTiles: false,
        musicFile: null,
        musicFileDeleted: false,
        backgroundImageFile: null,
        annotationImageFile: null,
        inGameBackgroundImageFile: null,
        backgroundImage: null,
        annotationImage: null,
        annotationImageFileDeleted: false,
        inGameBackgroundImage: null,
        backgroundImageUrl: "",
        annotationImageUrl: "",
        inGameBackgroundImageUrl: "",
        homeName: "",
        timer: 60,
        homeCoords: {
          longitude: 0,
          latitude: 0,
        },
        cameraBoundsNE: {
          longitude: 0,
          latitude: 0,
        },
        cameraBoundsSW: {
          longitude: 0,
          latitude: 0,
        },
        finalZoneId: null,
        showRateThisApp: false,
        launchZonesAfterEachOther: false,
      },
    };
    this.setSelectedTab = this.setSelectedTab.bind(this);
    this.backgroundMusicSelected = this.backgroundMusicSelected.bind(this);
    this.backgroundImageSelected = this.backgroundImageSelected.bind(this);
    this.inGameBackgroundImageSelected =
      this.inGameBackgroundImageSelected.bind(this);
    this.annotationImageSelected = this.annotationImageSelected.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.deleteMusic = this.deleteMusic.bind(this);
    this.deleteAnnotationImage = this.deleteAnnotationImage.bind(this);

    this.updateTitle = this.updateTitle.bind(this);
    this.updateSubtitle = this.updateSubtitle.bind(this);
    this.updateHomeAnnotationName = this.updateHomeAnnotationName.bind(this);
    this.updateRedirectToHomeWhileFinished =
      this.updateRedirectToHomeWhileFinished.bind(this);
    this.updateNeedDownloadMapTiles =
      this.updateNeedDownloadMapTiles.bind(this);
    this.updateMustAddAnalyticBeforeLaunch =
      this.updateMustAddAnalyticBeforeLaunch.bind(this);
    this.updateHomeName = this.updateHomeName.bind(this);
    this.updateTimer = this.updateTimer.bind(this);
    this.updateHomeCoordsLongitude = this.updateHomeCoordsLongitude.bind(this);
    this.updateHomeCoordsLatitude = this.updateHomeCoordsLatitude.bind(this);
    this.updateCameraBoundsNELongitude =
      this.updateCameraBoundsNELongitude.bind(this);
    this.updateCameraBoundsNELatitude =
      this.updateCameraBoundsNELatitude.bind(this);
    this.updateCameraBoundsSWLongitude =
      this.updateCameraBoundsSWLongitude.bind(this);
    this.updateCameraBoundsSWLatitude =
      this.updateCameraBoundsSWLatitude.bind(this);
    this.handleGameModeChange = this.handleGameModeChange.bind(this);
    this.updateCluesFree = this.updateCluesFree.bind(this);
    this.updateAskUserEmail = this.updateAskUserEmail.bind(this);

    this.onDragEnd = this.onDragEnd.bind(this);
    this.deleteZone = this.deleteZone.bind(this);
    this.openDeleteZoneDialog = this.openDeleteZoneDialog.bind(this);
    this.closeDeleteZoneDialog = this.closeDeleteZoneDialog.bind(this);

    this.setHomeLocation = this.setHomeLocation.bind(this);
    this.setCameraBoundsNELocation = this.setCameraBoundsNELocation.bind(this);
    this.setCameraBoundsSWLocation = this.setCameraBoundsSWLocation.bind(this);
    this.closeMapDialog = this.closeMapDialog.bind(this);
    this.openMapDialog = this.openMapDialog.bind(this);
    this.handleFinalZoneIdChanged = this.handleFinalZoneIdChanged.bind(this);
    this.deleteFinalZoneId = this.deleteFinalZoneId.bind(this);
    this.updateLaunchZonesAfterEachOther =
      this.updateLaunchZonesAfterEachOther.bind(this);
    this.resetErrorAlert = this.resetErrorAlert.bind(this);
    this.resetSuccessAlert = this.resetSuccessAlert.bind(this);
    this.updateShowRateThisApp = this.updateShowRateThisApp.bind(this);
  }

  componentDidMount() {
    const { t } = this.props;
    window.addEventListener("beforeunload", this.handleBeforeUnload);

    this.getAccount();

    let id = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).id;

    id = parseInt(id);

    this.setStateIsAdmin();

    let clientUserId = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).clientUserId;

    clientUserId = parseInt(clientUserId);
    if (!isNaN(clientUserId)) {
      this.setState((prevState) => ({
        ...prevState,

        formDatas: {
          ...prevState.formDatas,
          clientUserId:
            clientUserId != null && clientUserId != "" ? clientUserId : null,
        },
      }));
    }

    if (!id) {
      this.setState((prevState) => ({
        ...prevState,
        tourLoaded: true,
        zonesLoaded: true,
      }));
      return;
    }

    this.setState((prevState) => ({
      ...prevState,

      formDatas: {
        ...prevState.formDatas,
        tourId: id,
      },
    }));

    ApiTour.getTour(id).then((tourDatas) => {
      if (!tourDatas || tourDatas.status !== 200) {
        this.setState((prevState) => ({
          ...prevState,
          showError: true,
          errorMessage: t("newTour.error_retrieving_tour"),
          showSuccess: false,
          successMessage: "",
        }));

        return;
      }
      this.getFirstTestCode(id);
      this.setState((prevState) => ({
        ...prevState,
        editing: true,
        tourLoaded: true,
      }));

      this.setFormDatas(tourDatas.data);

      if (this.state.isAdmin) {
        this.getUserAccount(tourDatas.data?.UserId);
      }
    });

    ApiZone.getZones(id).then((zones) => {
      let zonesDatas = [];

      if (zones.status !== 200 && zones.status !== 204) {
        this.setState((prevState) => ({
          ...prevState,
          showError: true,
          errorMessage: t("newTour.error_retrieving_zones"),
          showSuccess: false,
          successMessage: "",
          zonesLoaded: true,
        }));

        return;
      }

      if (zones.status == 204) return;

      zones.data.forEach((elem, i) => {
        zonesDatas.push({
          name: elem.name,
          id: elem.id,
          isValid: elem.isValid,
          isActive: elem.isActive,
          orderId: elem.orderId,
          zoneMode: elem.zoneMode,
        });
      });

      this.setState((prevState) => ({
        ...prevState,
        zonesDatas: zonesDatas,
        zones: zones.data,
        zonesLoaded: true,
      }));
    });
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  }

  async getFirstTestCode(tourId) {
    const res = await ApiTour.getFirstTestCode(tourId);
    this.setState((prevState) => ({
      ...prevState,
      testCode: res.data?.code,
    }));
  }

  setSelectedTab = (value) => {
    this.setState((prevState) => ({
      ...prevState,
      selectedTab: value,
    }));
  };

  async getAccount() {
    let response = await ApiUser.getAccount();

    if (response.status == 200) {
      this.setState((prevState) => ({
        ...prevState,
        role: response.data.role,
        tutorialSteps: response.data.tutorialSteps,
      }));
    }
  }

  async getUserAccount(userId) {
    ApiAdmin.getUserAccount(userId).then((response) => {
      console.log("response user account ", response.data);
      if (response.status != 200 || !response.data) {
        this.setState((prevState) => ({
          ...prevState,
          showError: true,
          showSuccess: false,
          errorMessage:
            "Impossible de récupérer de données sur cette utilisateur",
        }));

        return;
      }
      this.setState((prevState) => ({
        ...prevState,
        adminFormDatas: {
          ...prevState.adminFormDatas,
          accountStripeConnectActive:
            response.data.stripeConnectUserInfos?.stripeConnectActive,
          accountStripeConnectAuthorized:
            response.data.stripeConnectUserInfos
              ?.accountStripeConnectAuthorized,
        },
      }));
    });
  }

  handleBeforeUnload = (event) => {
    const { t } = this.props;
    if (this.state.unsavedChanges) {
      const message = t("newTour.modifications_not_saved");
      event.returnValue = message;
      return message;
    }
  };

  async setHomeLocation(location) {
    if (!location || !location.lat || !location.lng) return;

    this.setState((prevState) => ({
      unsavedChanges: true,

      formDatas: {
        ...prevState.formDatas,
        homeCoords: {
          ...prevState.formDatas.homeCoords,
          longitude: location.lng,
          latitude: location.lat,
        },
      },
    }));
  }

  async setCameraBoundsNELocation(location) {
    if (!location || !location.lat || !location.lng) return;

    this.setState(
      (prevState) => ({
        ...prevState,
        unsavedChanges: true,

        formDatas: {
          ...prevState.formDatas,
          cameraBoundsNE: {
            ...prevState.formDatas.cameraBoundsNE,
            longitude: location.lng,
            latitude: location.lat,
          },
        },
      }),
      () => { }
    );
  }

  async setCameraBoundsSWLocation(location) {
    if (!location || !location.lat || !location.lng) return;

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,

      formDatas: {
        ...prevState.formDatas,
        cameraBoundsSW: {
          ...prevState.formDatas.cameraBoundsSW,
          longitude: location.lng,
          latitude: location.lat,
        },
      },
    }));
  }

  closeMapDialog() {
    this.setState((prevState) => ({
      ...prevState,
      mapDialogOpen: false,
    }));
  }

  openMapDialog(type) {
    let lat = null;
    let lng = null;
    if (type === "HOME") {
      lat = this.state.formDatas.homeCoords.latitude;
      lng = this.state.formDatas.homeCoords.longitude;
    } else if (type === "NE") {
      lat = this.state.formDatas.cameraBoundsNE.latitude;
      lng = this.state.formDatas.cameraBoundsNE.longitude;
    } else if (type === "SW") {
      lat = this.state.formDatas.cameraBoundsSW.latitude;
      lng = this.state.formDatas.cameraBoundsSW.longitude;
    }

    this.setState(
      (prevState) => ({
        ...prevState,

        mapDialogOpen: true,
        mapType: type,
        showLatOnMap: lat,
        showLngOnMap: lng,
      }),
      () => { }
    );
  }

  async setStateIsAdmin() {
    let response = await ApiUser.isAdmin();

    if (response.status == 200) {
      this.setState((prevState) => ({
        ...prevState,
        isAdmin: response.data.isAdmin,
      }));
    }
  }

  async setFormDatas(tour) {
    console.log("tour ", tour);
    this.setState((prevState) => ({
      ...prevState,
      tourLoaded: true,
      formDatas: {
        ...prevState.formDatas,
        userAskedMonetization: tour.userAskedMonetization,
        tourId: tour.id,
        disabled: tour.disabled,
        title: tour.title,
        subtitle: tour.subtitle,
        homeAnnotationName: tour.homeAnnotationName,
        redirectToHomeWhileFinished: tour.redirectToHomeWhileFinished,
        needDownloadMapTiles: tour.needDownloadMapTiles,
        mustAddAnalyticBeforeLaunch: tour.mustAddAnalyticBeforeLaunch,
        cluesFree: tour.cluesFree,
        askUserEmail: tour.askUserEmail || false,
        backgroundImageUrl: tour.backgroundImage?.signedUrl,
        annotationImageUrl: tour.annotationImage?.signedUrl,
        inGameBackgroundImageUrl: tour.inGameBackgroundImage?.signedUrl,
        gameMode: tour.gameMode,
        homeName: tour.homeName,
        timer: tour.timer,
        musicFileName: tour.music?.name,
        homeCoords: {
          longitude: tour.homeCoordsLongitude,
          latitude: tour.homeCoordsLatitude,
        },
        cameraBoundsNE: {
          longitude: tour.cameraBoundsNELongitude,
          latitude: tour.cameraBoundsNELatitude,
        },
        cameraBoundsSW: {
          longitude: tour.cameraBoundsSWLongitude,
          latitude: tour.cameraBoundsSWLatitude,
        },
        finalZoneId: tour.finalZoneId,
        showRateThisApp: tour.showRateThisApp || false,
        launchZonesAfterEachOther: tour.launchZonesAfterEachOther || false,
      },
      adminFormDatas: {
        userCanMonetizedTour: tour.userCanMonetizedTour || false,
        stripeConnectCommissionPercent:
          tour.stripeConnectCommissionPercent || 0,
        StripeConnectComissionFix: tour.StripeConnectComissionFix || 0,
      },
    }));
  }

  handleGameModeChange(event, value) {
    event.preventDefault();

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,

        gameMode: event.target.value,
      },
    }));
  }

  handleFinalZoneIdChanged(event) {
    const value = event.target.value;
    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        finalZoneId: value,
      },
    }));
  }

  deleteFinalZoneId() {
    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        finalZoneId: null,
      },
    }));
  }

  updateLaunchZonesAfterEachOther(event) {
    const value = event.target.checked;

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        launchZonesAfterEachOther: value,
      },
    }));
  }

  updateTitle(event) {
    event.preventDefault();

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,

      formDatas: {
        ...prevState.formDatas,
        title: event.target.value,
      },
    }));
  }
  updateSubtitle(event) {
    event.preventDefault();

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,

      formDatas: {
        ...prevState.formDatas,
        subtitle: event.target.value,
      },
    }));
  }
  updateHomeAnnotationName(event) {
    event.preventDefault();

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,

      formDatas: {
        ...prevState.formDatas,
        homeAnnotationName: event.target.value,
      },
    }));
  }

  updateRedirectToHomeWhileFinished(event) {
    // event.preventDefault();
    const value = event.target.checked;

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        redirectToHomeWhileFinished: value,
      },
    }));
  }

  updateCluesFree(event) {
    // event.preventDefault();
    const value = event.target.checked;

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        cluesFree: value,
      },
    }));
  }

  updateAskUserEmail(event) {
    // event.preventDefault();
    const value = event.target.checked;

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        askUserEmail: value,
      },
    }));
  }

  updateNeedDownloadMapTiles(event) {
    const value = event.target.checked;

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        needDownloadMapTiles: value,
      },
    }));
  }

  updateShowRateThisApp(event) {
    const value = event.target.checked;

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        showRateThisApp: value,
      },
    }));
  }

  updateMustAddAnalyticBeforeLaunch(event) {
    const value = event.target.checked;

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        mustAddAnalyticBeforeLaunch: value,
      },
    }));
  }

  updateHomeName(event) {
    event.preventDefault();

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,

      formDatas: {
        ...prevState.formDatas,
        homeName: event.target.value,
      },
    }));
  }

  updateTimer(event, value) {
    event.preventDefault();

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,

      formDatas: {
        ...prevState.formDatas,
        timer: parseInt(event.target.value),
      },
    }));
  }

  updateHomeCoordsLongitude(event) {
    event.preventDefault();

    let value = event.target.value;

    if (isNaN(parseFloat(value))) {
      value = 0;
    } else {
      value = parseFloat(value);
    }
    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,

      formDatas: {
        ...prevState.formDatas,
        homeCoords: {
          ...prevState.formDatas.homeCoords,
          longitude: value,
        },
      },
    }));
  }

  updateHomeCoordsLatitude(event) {
    event.preventDefault();

    let value = event.target.value;

    if (isNaN(parseFloat(value))) {
      value = 0;
    } else {
      value = parseFloat(value);
    }

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,

      formDatas: {
        ...prevState.formDatas,
        homeCoords: {
          ...prevState.formDatas.homeCoords,
          latitude: value,
        },
      },
    }));
  }

  updateCameraBoundsNELongitude(event) {
    event.preventDefault();

    let value = event.target.value;

    if (isNaN(parseFloat(value))) {
      value = 0;
    } else {
      value = parseFloat(value);
    }

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,

      formDatas: {
        ...prevState.formDatas,
        cameraBoundsNE: {
          ...prevState.formDatas.cameraBoundsNE,
          longitude: value,
        },
      },
    }));
  }

  updateCameraBoundsNELatitude(event) {
    event.preventDefault();

    let value = event.target.value;

    if (isNaN(parseFloat(value))) {
      value = 0;
    } else {
      value = parseFloat(value);
    }

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,

      formDatas: {
        ...prevState.formDatas,
        cameraBoundsNE: {
          ...prevState.formDatas.cameraBoundsNE,
          latitude: value,
        },
      },
    }));
  }

  updateCameraBoundsSWLongitude(event) {
    event.preventDefault();

    let value = event.target.value;

    if (isNaN(parseFloat(value))) {
      value = 0;
    } else {
      value = parseFloat(value);
    }

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,

      formDatas: {
        ...prevState.formDatas,
        cameraBoundsSW: {
          ...prevState.formDatas.cameraBoundsSW,
          longitude: value,
        },
      },
    }));
  }

  updateCameraBoundsSWLatitude(event) {
    event.preventDefault();

    let value = event.target.value;

    if (isNaN(parseFloat(value))) {
      value = 0;
    } else {
      value = parseFloat(value);
    }

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,

      formDatas: {
        ...prevState.formDatas,
        cameraBoundsSW: {
          ...prevState.formDatas.cameraBoundsSW,
          latitude: value,
        },
      },
    }));
  }

  inGameBackgroundImageSelected(event) {
    event.preventDefault();

    if (!event.target.files || !event.target.files[0]) {
      return;
    }

    let fileSizeMb = getSizeInMb(event.target.files[0].size);

    if (fileSizeMb > 15) {
      this.setState((prevState) => ({
        ...prevState,
        showInGameBackgroundImageTooBig: true,
      }));

      return;
    }

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,

      showInGameBackgroundImageTooBig: false,
      formDatas: {
        ...prevState.formDatas,
        inGameBackgroundImageFile: event.target.files[0],
      },
    }));
  }

  deleteAnnotationImage() {
    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      showAnnotationImageTooBig: false,
      formDatas: {
        ...prevState.formDatas,
        annotationImageFile: null,
        annotationImageFileDeleted: true,
        annotationImageUrl: null,
      },
    }));
  }

  deleteMusic() {
    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      showMusicFileTooBig: false,
      formDatas: {
        ...prevState.formDatas,
        musicFile: null,
        musicFileDeleted: true,
        musicFileName: null,
      },
    }));
  }

  backgroundMusicSelected(event) {
    event.preventDefault();

    if (!event.target.files || !event.target.files[0]) {
      return;
    }

    let fileSizeMb = getSizeInMb(event.target.files[0].size);

    if (fileSizeMb > 10) {
      this.setState((prevState) => ({
        ...prevState,
        showMusicFileTooBig: true,
      }));

      return;
    }

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      showMusicFileTooBig: false,
      formDatas: {
        ...prevState.formDatas,
        musicFile: event.target.files[0],
        musicFileDeleted: false,
      },
    }));
  }

  backgroundImageSelected(event) {
    event.preventDefault();

    if (!event.target.files || !event.target.files[0]) {
      return;
    }

    let fileSizeMb = getSizeInMb(event.target.files[0].size);

    if (fileSizeMb > 15) {
      this.setState((prevState) => ({
        ...prevState,
        showBackgroundImageTooBig: true,
      }));

      return;
    }

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      showBackgroundImageTooBig: false,
      formDatas: {
        ...prevState.formDatas,
        backgroundImageFile: event.target.files[0],
      },
    }));
  }

  annotationImageSelected(event) {
    event.preventDefault();

    if (!event.target.files || !event.target.files[0]) {
      return;
    }

    let fileSizeMb = getSizeInMb(event.target.files[0].size);

    if (fileSizeMb > 15) {
      this.setState((prevState) => ({
        ...prevState,
        showAnnotationImageTooBig: true,
      }));

      return;
    }

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,

      showAnnotationImageTooBig: false,
      formDatas: {
        ...prevState.formDatas,
        showAnnotationImageTooBig: false,
        annotationImageFile: event.target.files[0],
        annotationImageFileDeleted: false,
      },
    }));
  }

  async isAdmin() {
    let response = await ApiUser.isAdmin();

    if (response.status == 200 && response.data.isAdmin) {
      return true;
    }
  }

  async submitForm(event) {
    event.preventDefault();
    const { t } = this.props;

    if (
      this.state.role === "NO_SUBSCRIBTION" ||
      this.state.formDatas?.disabled
    ) {
      return;
    }

    if (
      !this.state.formDatas.title ||
      this.state.formDatas.title.trim() === ""
    ) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("newTour.title_required"),
        showSuccess: false,
        successMessage: "",
      }));
      return;
    }

    if (
      !this.state.formDatas.subtitle ||
      this.state.formDatas.subtitle.trim() === ""
    ) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("newTour.subtitle_required"),
        showSuccess: false,
        successMessage: "",
      }));
      return;
    }

    if (!this.state.formDatas.timer || this.state.formDatas.timer < 0) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("newTour.timer_required"),
        showSuccess: false,
        successMessage: "",
      }));
      return;
    }

    var serverResp = null;
    if (this.state.formDatas.gameMode === GameMode.MAP_AND_QRCODE) {
      if (
        (!this.state.formDatas.homeCoords.longitude ||
          !this.state.formDatas.homeCoords.latitude) &&
        this.state.formDatas.redirectToHomeWhileFinished
      ) {
        this.setState((prevState) => ({
          ...prevState,
          showError: true,
          errorMessage: t("newTour.no_coords"),
          showSuccess: false,
          successMessage: "",
        }));

        return;
      }
      if (
        !this.state.formDatas.cameraBoundsNE.longitude ||
        !this.state.formDatas.cameraBoundsNE.latitude
      ) {
        this.setState((prevState) => ({
          ...prevState,
          showError: true,
          errorMessage: t("newTour.no_ne_coords"),
          showSuccess: false,
          successMessage: "",
        }));

        return;
      }
      if (
        !this.state.formDatas.cameraBoundsSW.longitude ||
        !this.state.formDatas.cameraBoundsSW.latitude
      ) {
        this.setState((prevState) => ({
          ...prevState,
          showError: true,
          errorMessage: t("newTour.no_sw_coords"),
          showSuccess: false,
          successMessage: "",
        }));

        return;
      }
    }

    if (this.state.editing) {
      this.setState((prevState) => ({
        ...prevState,
        loadingViewOpened: true,
      }));
      if (
        ((!this.state.formDatas.annotationImageFile &&
          !this.state.formDatas.annotationImageUrl) ||
          this.state.formDatas.annotationImageFileDeleted) &&
        this.state.formDatas.redirectToHomeWhileFinished &&
        this.state.formDatas.gameMode == GameMode.MAP_AND_QRCODE
      ) {
        this.setState((prevState) => ({
          ...prevState,
          showError: true,
          loadingViewOpened: false,
          errorMessage: t("newTour.annotation_image_missing"),
          showSuccess: false,
          successMessage: "",
        }));

        return;
      }
      serverResp = await ApiTour.updateTour(
        this.state.formDatas,
        this.state.formDatas.tourId
      );
      if (this.state.zonesOrderIdsChanged) {
        let res = await ApiZone.updateZonesOrdersIds(this.state.zonesDatas);
      }
    } else {
      if (this.state.formDatas.backgroundImageFile == null) {
        this.setState((prevState) => ({
          ...prevState,
          showError: true,
          errorMessage: t("newTour.background_image_missing"),
          showSuccess: false,
          successMessage: "",
        }));

        return;
      }
      if (
        ((!this.state.formDatas.annotationImageFile &&
          !this.state.formDatas.annotationImageUrl) ||
          this.state.formDatas.annotationImageFileDeleted) &&
        this.state.formDatas.redirectToHomeWhileFinished &&
        this.state.formDatas.gameMode == GameMode.MAP_AND_QRCODE
      ) {
        this.setState((prevState) => ({
          ...prevState,
          showError: true,
          loadingViewOpened: false,
          errorMessage: t("newTour.annotation_image_missing"),
          showSuccess: false,
          successMessage: "",
        }));

        return;
      }

      this.setState((prevState) => ({
        ...prevState,
        loadingViewOpened: true,
      }));
      let admin = await this.isAdmin();
      if (
        admin &&
        this.state.formDatas.clientUserId != null &&
        this.clientUserId != ""
      ) {
        serverResp = await ApiAdmin.uploadClientTour(this.state.formDatas);
      } else {
        serverResp = await ApiTour.uploadTour(this.state.formDatas);
      }
    }

    if (serverResp.status == 403) {
      this.setState((prevState) => ({
        ...prevState,
        showSuccess: false,
        showError: true,
        errorMessage: t("newTour.max_tours_reached"),
        dialogWaringOpened: false,
        loadingViewOpened: false,
      }));
    } else if (serverResp.status != 201 && serverResp.status != 200) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("newTour.error_server_communication"),
        showSuccess: false,
        successMessage: "",
        loadingViewOpened: false,
      }));
    } else {
      this.setState((prevState) => ({
        ...prevState,
        showSuccess: true,
        unsavedChanges: false,
        editing: true,
        successMessage: t("newTour.success_tour_saved"),
        showError: false,
        errorMessage: "",
        loadingViewOpened: false,
        formDatas: {
          ...prevState.formDatas,
          tourId: serverResp.data.tourId,
        },
      }));
    }
  }

  onDragEnd = ({ destination, source }) => {
    if (!destination) return;

    const zonesDatas = this.state.zonesDatas;

    let zoneSource = zonesDatas.find((zone, i) => {
      return i === source.index;
    });
    let zoneDest = zonesDatas.find((zone, i) => {
      return i === destination.index;
    });

    zonesDatas.splice(
      destination.index,
      0,
      zonesDatas.splice(source.index, 1)[0]
    );

    zonesDatas.forEach((zone, i) => {
      zone.orderId = i;
    });

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      zonesOrderIdsChanged: true,
      zonesDatas: zonesDatas,
    }));
  };

  async deleteZone(zoneId) {
    const { t } = this.props;
    let res = await ApiZone.deleteZone(zoneId);

    if (res.status == 200) {
      let newZones = this.state.zonesDatas;
      newZones.forEach((zone, index) => {
        if (zone.id == zoneId) {
          newZones.splice(index, 1);
        }
      });
      this.setState((prevState) => ({
        ...prevState,
        showSuccess: true,
        successMessage: t("newTour.zone_deleted"),
        showError: false,
        dialogWaringOpened: false,
        zonesDatas: newZones,
      }));
    } else {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("newTour.zone_delete_error"),
        showSuccess: false,
        successMessage: "",
        dialogWaringOpened: false,
      }));
    }
  }

  openDeleteZoneDialog(zoneId) {
    this.setState((prevState) => ({
      ...prevState,
      zoneIdToDelete: zoneId,
      dialogWaringOpened: true,
    }));
  }

  closeDeleteZoneDialog() {
    this.setState((prevState) => ({
      ...prevState,
      dialogWaringOpened: false,
    }));
  }

  getZonesItems() {
    const zonesItems = [];
    if (this.state.zonesDatas) {
      this.state.zonesDatas.forEach((zone) => {
        let icon = <LocationOnIcon />;
        if (zone.zoneMode == ZoneMode.QRCODE) {
          icon = <QrIcon />;
        }
        let item = {
          id: `zone-${zone.id}`,
          idInt: zone.id,
          primary: zone.name,
          secondary: "",
          to: `/zone?tourId=${this.state.formDatas.tourId}&zoneId=${zone.id}`,
          icon: icon,
          isValid: zone.isValid,
          isActive: zone.isActive,
        };

        zonesItems.push(item);
      });
    }
    console.log("zones itmes :", zonesItems);
    return zonesItems;
  }

  resetErrorAlert() {
    this.setState((prevState) => ({
      ...prevState,
      showError: false,
      errorMessage: "",
    }));
  }

  resetSuccessAlert() {
    this.setState((prevState) => ({
      ...prevState,
      showSuccess: false,
      successMessage: "",
    }));
  }

  updateUserCanMonetizedTour = (event) => {
    const value = event.target.checked;
    this.setState((prevState) => ({
      ...prevState,
      adminFormDatas: {
        ...prevState.adminFormDatas,
        userCanMonetizedTour: value,
      },
    }));
  };

  updateStripeConnectCommissionPercent = (event) => {
    const value = parseFloat(event.target.value) || 0;
    this.setState((prevState) => ({
      ...prevState,
      adminFormDatas: {
        ...prevState.adminFormDatas,
        stripeConnectCommissionPercent: value,
      },
    }));
  };

  updateStripeConnectComissionFix = (event) => {
    const value = parseFloat(event.target.value) || 0;
    this.setState((prevState) => ({
      ...prevState,
      adminFormDatas: {
        ...prevState.adminFormDatas,
        StripeConnectComissionFix: value,
      },
    }));
  };

  handleStripeConnectSubmit = async (event) => {
    event.preventDefault();
    const { t } = this.props;

    try {
      const response = await ApiAdmin.updateStripeConnectTourValues(
        this.state.formDatas.tourId,
        this.state.adminFormDatas
      );

      if (response.status === 200) {
        this.setState((prevState) => ({
          ...prevState,
          showSuccess: true,
          successMessage: t("newTour.stripe_connect_success"),
          showError: false,
        }));
      }
    } catch (error) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("newTour.stripe_connect_error"),
        showSuccess: false,
      }));
    }
  };

  render() {
    return (
      <TourView
        {...this.props}
        state={this.state}
        setSelectedTab={this.setSelectedTab}
        updateTitle={this.updateTitle}
        updateSubtitle={this.updateSubtitle}
        submitForm={this.submitForm}
        deleteMusic={this.deleteMusic}
        deleteAnnotationImage={this.deleteAnnotationImage}
        backgroundMusicSelected={this.backgroundMusicSelected}
        backgroundImageSelected={this.backgroundImageSelected}
        handleGameModeChange={this.handleGameModeChange}
        inGameBackgroundImageSelected={this.inGameBackgroundImageSelected}
        annotationImageSelected={this.annotationImageSelected}
        updateHomeCoordsLongitude={this.updateHomeCoordsLongitude}
        updateHomeCoordsLatitude={this.updateHomeCoordsLatitude}
        updateCameraBoundsNELongitude={this.updateCameraBoundsNELongitude}
        updateCameraBoundsNELatitude={this.updateCameraBoundsNELatitude}
        updateCameraBoundsSWLongitude={this.updateCameraBoundsSWLongitude}
        updateCameraBoundsSWLatitude={this.updateCameraBoundsSWLatitude}
        updateHomeAnnotationName={this.updateHomeAnnotationName}
        updateRedirectToHomeWhileFinished={
          this.updateRedirectToHomeWhileFinished
        }
        handleFinalZoneIdChanged={this.handleFinalZoneIdChanged}
        deleteFinalZoneId={this.deleteFinalZoneId}
        updateLaunchZonesAfterEachOther={this.updateLaunchZonesAfterEachOther}
        updateCluesFree={this.updateCluesFree}
        updateAskUserEmail={this.updateAskUserEmail}
        updateNeedDownloadMapTiles={this.updateNeedDownloadMapTiles}
        updateMustAddAnalyticBeforeLaunch={
          this.updateMustAddAnalyticBeforeLaunch
        }
        valueSliderTourTimer={this.valueSliderTourTimer}
        updateTimer={this.updateTimer}
        onDragEnd={this.onDragEnd}
        openDeleteZoneDialog={this.openDeleteZoneDialog}
        deleteZone={this.deleteZone}
        closeDeleteZoneDialog={this.closeDeleteZoneDialog}
        getZonesItems={this.getZonesItems}
        setHomeLocation={this.setHomeLocation}
        setCameraBoundsNELocation={this.setCameraBoundsNELocation}
        setCameraBoundsSWLocation={this.setCameraBoundsSWLocation}
        mapDialogOpen={this.state.mapDialogOpen}
        closeMapDialog={this.closeMapDialog}
        openMapDialog={this.openMapDialog}
        mapType={this.state.mapType}
        showLatOnMap={this.state.showLatOnMap}
        showLngOnMap={this.state.showLngOnMap}
        resetErrorAlert={this.resetErrorAlert}
        resetSuccessAlert={this.resetSuccessAlert}
        updateUserCanMonetizedTour={this.updateUserCanMonetizedTour}
        updateStripeConnectCommissionPercent={
          this.updateStripeConnectCommissionPercent
        }
        updateStripeConnectComissionFix={this.updateStripeConnectComissionFix}
        handleStripeConnectSubmit={this.handleStripeConnectSubmit}
        updateShowRateThisApp={this.updateShowRateThisApp}
      />
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  withTranslation()(NewTour)
);
